import { BrandSearchFilterC } from "app/search/codecs/BrandSearchFilterC"
import { withDelimited } from "app/search/codecs/withDelimited"

export const DelimitedFiltersC = withDelimited(BrandSearchFilterC)
